module.exports = __webpack_public_path__ + "static/media/search_icon--white.fc35d4b6.svg";